import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/app/Navbar";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Check, Zap } from "lucide-react";

export default function Pricing() {
  const { user, refresh } = useAuth();
  const [plans, setPlans] = useState({});
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data.plans)); }, []);

  const subscribe = async (p) => {
    if (!user) { toast.error("Log in first"); return; }
    await api.post(`/plans/subscribe/${p}`);
    await refresh();
    toast.success(`You're on ${p} now`);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold mb-3">Plans</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium">Freemium, honestly priced.</h1>
          <p className="text-stone-600 mt-3">Post for free forever. Boost when you want more eyeballs.</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {Object.entries(plans).map(([key, p]) => (
            <div key={key} data-testid={`plan-${key}`} className={`p-8 rounded-2xl border ${key === "plus" ? "border-[#2A4B3C] bg-white shadow-lg" : "border-stone-200 bg-white"}`}>
              {key === "plus" && <div className="chip bg-[#2A4B3C]/10 text-[#2A4B3C] mb-4"><Zap className="w-3 h-3 mr-1" /> Most popular</div>}
              <div className="font-display text-2xl font-medium capitalize">{key}</div>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="font-display text-4xl font-semibold">₹{p.price}</span>
                <span className="text-stone-500 text-sm">/month</span>
              </div>
              <ul className="mt-6 space-y-2">
                {p.features?.map((f) => (
                  <li key={f} className="flex items-start gap-2 text-sm text-stone-700"><Check className="w-4 h-4 text-brand mt-0.5" /> {f}</li>
                ))}
              </ul>
              <Button data-testid={`subscribe-${key}`}
                className={`w-full mt-8 rounded-full ${key === "plus" || key === "premium" ? "brand-accent" : "brand-primary"}`}
                onClick={() => subscribe(key)} disabled={user?.plan === key}>
                {user?.plan === key ? "Current plan" : (p.price === 0 ? "Get started" : "Upgrade")}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
